/* tslint:disable */
/* eslint-disable */
/**
 * File API
 * API for managing files
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ContextEnum,
  DevisDocumentInfoResponse,
  DocumentsUrlResponse,
  ErrorResponse,
  FileTypeEnum,
  OperationResponse,
  UrlOperationResponse,
} from '../models/index';
import {
    ContextEnumFromJSON,
    ContextEnumToJSON,
    DevisDocumentInfoResponseFromJSON,
    DevisDocumentInfoResponseToJSON,
    DocumentsUrlResponseFromJSON,
    DocumentsUrlResponseToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FileTypeEnumFromJSON,
    FileTypeEnumToJSON,
    OperationResponseFromJSON,
    OperationResponseToJSON,
    UrlOperationResponseFromJSON,
    UrlOperationResponseToJSON,
} from '../models/index';

export interface DeleteFileByStoredFileIdRequest {
    storedFileId: string;
}

export interface GetContratTemporaryDocumentsUrlsRequest {
    contratId: string;
    expirationMinutes?: number;
}

export interface GetDevisDocumentInfoRequest {
    devisId: string;
    fileType: FileTypeEnum;
}

export interface GetDevisTemporaryDocumentsUrlsRequest {
    devisId: string;
    expirationMinutes?: number;
}

export interface GetTemporaryUrlRequest {
    storedFileId: string;
    expirationMinutes?: number;
}

export interface UploadFileRequest {
    fileType: FileTypeEnum;
    context: ContextEnum;
    objetId: string;
    file: Blob;
}

export interface UploadFileByTypeRequest {
    fileType: FileTypeEnum;
    file: Blob;
}

/**
 * 
 */
export class FilesApi extends runtime.BaseAPI {

    /**
     * Delete File by storedFileId
     */
    async deleteFileByStoredFileIdRaw(requestParameters: DeleteFileByStoredFileIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['storedFileId'] == null) {
            throw new runtime.RequiredError(
                'storedFileId',
                'Required parameter "storedFileId" was null or undefined when calling deleteFileByStoredFileId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/files/{storedFileId}`.replace(`{${"storedFileId"}}`, encodeURIComponent(String(requestParameters['storedFileId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Delete File by storedFileId
     */
    async deleteFileByStoredFileId(requestParameters: DeleteFileByStoredFileIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.deleteFileByStoredFileIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves temporary URLs for all documents associated with a contract
     * Get temporary URLs for contract documents
     */
    async getContratTemporaryDocumentsUrlsRaw(requestParameters: GetContratTemporaryDocumentsUrlsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentsUrlResponse>> {
        if (requestParameters['contratId'] == null) {
            throw new runtime.RequiredError(
                'contratId',
                'Required parameter "contratId" was null or undefined when calling getContratTemporaryDocumentsUrls().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['expirationMinutes'] != null) {
            queryParameters['expirationMinutes'] = requestParameters['expirationMinutes'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/files/contrats/{contratId}/urls`.replace(`{${"contratId"}}`, encodeURIComponent(String(requestParameters['contratId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentsUrlResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves temporary URLs for all documents associated with a contract
     * Get temporary URLs for contract documents
     */
    async getContratTemporaryDocumentsUrls(requestParameters: GetContratTemporaryDocumentsUrlsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentsUrlResponse> {
        const response = await this.getContratTemporaryDocumentsUrlsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Tells whether the quote carries a document of this file type, and how to open or remove it
     * Get the state of a quote justification document
     */
    async getDevisDocumentInfoRaw(requestParameters: GetDevisDocumentInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevisDocumentInfoResponse>> {
        if (requestParameters['devisId'] == null) {
            throw new runtime.RequiredError(
                'devisId',
                'Required parameter "devisId" was null or undefined when calling getDevisDocumentInfo().'
            );
        }

        if (requestParameters['fileType'] == null) {
            throw new runtime.RequiredError(
                'fileType',
                'Required parameter "fileType" was null or undefined when calling getDevisDocumentInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/files/devis/{devisId}/type/{fileType}`.replace(`{${"devisId"}}`, encodeURIComponent(String(requestParameters['devisId']))).replace(`{${"fileType"}}`, encodeURIComponent(String(requestParameters['fileType']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevisDocumentInfoResponseFromJSON(jsonValue));
    }

    /**
     * Tells whether the quote carries a document of this file type, and how to open or remove it
     * Get the state of a quote justification document
     */
    async getDevisDocumentInfo(requestParameters: GetDevisDocumentInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevisDocumentInfoResponse> {
        const response = await this.getDevisDocumentInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves temporary URLs for all documents associated with a quote
     * Get temporary URLs for quote documents
     */
    async getDevisTemporaryDocumentsUrlsRaw(requestParameters: GetDevisTemporaryDocumentsUrlsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentsUrlResponse>> {
        if (requestParameters['devisId'] == null) {
            throw new runtime.RequiredError(
                'devisId',
                'Required parameter "devisId" was null or undefined when calling getDevisTemporaryDocumentsUrls().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['expirationMinutes'] != null) {
            queryParameters['expirationMinutes'] = requestParameters['expirationMinutes'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/files/devis/{devisId}/urls`.replace(`{${"devisId"}}`, encodeURIComponent(String(requestParameters['devisId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentsUrlResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves temporary URLs for all documents associated with a quote
     * Get temporary URLs for quote documents
     */
    async getDevisTemporaryDocumentsUrls(requestParameters: GetDevisTemporaryDocumentsUrlsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentsUrlResponse> {
        const response = await this.getDevisTemporaryDocumentsUrlsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a temporary URL for accessing a file stored in blob storage
     * Get temporary URL for a stored file
     */
    async getTemporaryUrlRaw(requestParameters: GetTemporaryUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UrlOperationResponse>> {
        if (requestParameters['storedFileId'] == null) {
            throw new runtime.RequiredError(
                'storedFileId',
                'Required parameter "storedFileId" was null or undefined when calling getTemporaryUrl().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['expirationMinutes'] != null) {
            queryParameters['expirationMinutes'] = requestParameters['expirationMinutes'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/files/{storedFileId}/url`.replace(`{${"storedFileId"}}`, encodeURIComponent(String(requestParameters['storedFileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UrlOperationResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a temporary URL for accessing a file stored in blob storage
     * Get temporary URL for a stored file
     */
    async getTemporaryUrl(requestParameters: GetTemporaryUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UrlOperationResponse> {
        const response = await this.getTemporaryUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload file
     * Upload un fichier
     */
    async uploadFileRaw(requestParameters: UploadFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['fileType'] == null) {
            throw new runtime.RequiredError(
                'fileType',
                'Required parameter "fileType" was null or undefined when calling uploadFile().'
            );
        }

        if (requestParameters['context'] == null) {
            throw new runtime.RequiredError(
                'context',
                'Required parameter "context" was null or undefined when calling uploadFile().'
            );
        }

        if (requestParameters['objetId'] == null) {
            throw new runtime.RequiredError(
                'objetId',
                'Required parameter "objetId" was null or undefined when calling uploadFile().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling uploadFile().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['objetId'] != null) {
            queryParameters['objetId'] = requestParameters['objetId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request({
            path: `/api/backoffice/files/type/{fileType}/contexte/{context}`.replace(`{${"fileType"}}`, encodeURIComponent(String(requestParameters['fileType']))).replace(`{${"context"}}`, encodeURIComponent(String(requestParameters['context']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Upload file
     * Upload un fichier
     */
    async uploadFile(requestParameters: UploadFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.uploadFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Permet d\'uploader un fichier avec un type spécifique
     * Upload un fichier
     */
    async uploadFileByTypeRaw(requestParameters: UploadFileByTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['fileType'] == null) {
            throw new runtime.RequiredError(
                'fileType',
                'Required parameter "fileType" was null or undefined when calling uploadFileByType().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling uploadFileByType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request({
            path: `/api/backoffice/files/type/{fileType}`.replace(`{${"fileType"}}`, encodeURIComponent(String(requestParameters['fileType']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Permet d\'uploader un fichier avec un type spécifique
     * Upload un fichier
     */
    async uploadFileByType(requestParameters: UploadFileByTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.uploadFileByTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
